// See user roles in app/models/user.rb
export const ADMIN_ROLE = "admin"
export const NON_ADMIN_ROLE = "non_admin"
export const PHP_ADMIN_ROLE = "php_admin"
